// src/helpers/studio-css-variables.ts
var studioCssVariables = `
:where(:root) {
  --remotion-studio-black: black;
  --remotion-studio-white: white;
  --remotion-studio-red: red;
  --remotion-studio-transparent: transparent;
  --remotion-studio-current-color: currentColor;
  --remotion-studio-background: rgb(31,36,40);
  --remotion-studio-background-transparent: rgba(31,36,40, 0);
  --remotion-studio-input-background: #2f363d;
  --remotion-studio-tab-hover-background: #232629;
  --remotion-studio-light-color: #ddd;
  --remotion-studio-light-text: #A6A7A9;
  --remotion-studio-ruler-color: #808080;
  --remotion-studio-white-alpha-05: rgba(255, 255, 255, 0.05);
  --remotion-studio-white-alpha-06: rgba(255, 255, 255, 0.06);
  --remotion-studio-white-alpha-08: rgba(255, 255, 255, 0.08);
  --remotion-studio-white-alpha-10: rgba(255, 255, 255, 0.1);
  --remotion-studio-white-alpha-12: rgba(255, 255, 255, 0.12);
  --remotion-studio-white-alpha-15: rgba(255, 255, 255, 0.15);
  --remotion-studio-white-alpha-20: rgba(255, 255, 255, 0.2);
  --remotion-studio-white-alpha-25: rgba(255, 255, 255, 0.25);
  --remotion-studio-white-alpha-30: rgba(255, 255, 255, 0.3);
  --remotion-studio-white-alpha-35: rgba(255, 255, 255, 0.35);
  --remotion-studio-white-alpha-40: rgba(255, 255, 255, 0.4);
  --remotion-studio-white-alpha-45: rgba(255, 255, 255, 0.45);
  --remotion-studio-white-alpha-50: rgba(255, 255, 255, 0.5);
  --remotion-studio-white-alpha-60: rgba(255, 255, 255, 0.6);
  --remotion-studio-white-alpha-70: rgba(255, 255, 255, 0.7);
  --remotion-studio-white-alpha-72: rgba(255, 255, 255, 0.72);
  --remotion-studio-white-alpha-80: rgba(255, 255, 255, 0.8);
  --remotion-studio-white-alpha-90: rgba(255, 255, 255, 0.9);
  --remotion-studio-black-alpha-28: rgba(0, 0, 0, 0.28);
  --remotion-studio-black-alpha-30: rgba(0, 0, 0, 0.3);
  --remotion-studio-black-alpha-40: rgba(0, 0, 0, 0.4);
  --remotion-studio-black-alpha-50: rgba(0, 0, 0, 0.5);
  --remotion-studio-black-alpha-60: rgba(0, 0, 0, 0.6);
  --remotion-studio-black-alpha-80: rgba(0, 0, 0, 0.8);
  --remotion-studio-black-alpha-85: rgba(0, 0, 0, 0.85);
  --remotion-studio-black-alpha-90: rgba(0, 0, 0, 0.9);
  --remotion-studio-fail-color: #ff3232;
  --remotion-studio-warning-color: #f1c40f;
  --remotion-studio-blue: #0b84f3;
  --remotion-studio-blue-hovered: #4da3f7;
  --remotion-studio-blue-disabled: #284f73;
  --remotion-studio-unselected-guide: #7e1219;
  --remotion-studio-selected-guide: #d22d3a;
  --remotion-studio-line-color: #363A3E;
  --remotion-studio-timeline-track-separator: #13161B;
  --remotion-studio-light-gray: #ccc;
  --remotion-studio-keyboard-shortcut-key-color: #eee;
  --remotion-studio-notification-background: #111111;
  --remotion-studio-render-status-background: #222;
  --remotion-studio-error-code-frame-background: #070707;
  --remotion-studio-error-code-frame-line-background: #121212;
  --remotion-studio-error-link-color: #58a6ff;
  --remotion-studio-info-blue: #60a5fa;
  --remotion-studio-server-disconnected-background: #e74c3c;
  --remotion-studio-timeline-background-color: #15181B;
  --remotion-studio-timeline-negative-start-background-color: #2C2F32;
  --remotion-studio-timeline-negative-start-border-color: #414446;
  --remotion-studio-timeline-selected-background-color: #3B3F42;
  --remotion-studio-timeline-selected-label-background-color: #B0B0B0;
  --remotion-studio-timeline-blue: #0b84ff;
  --remotion-studio-timeline-playhead-color: #f02c00;
  --remotion-studio-timeline-drop-blue-alpha-12: rgba(0, 155, 255, 0.12);
  --remotion-studio-timeline-drop-blue-alpha-16: rgba(0, 155, 255, 0.16);
  --remotion-studio-timeline-drop-blue-alpha-75: rgba(0, 155, 255, 0.75);
  --remotion-studio-timeline-marquee-blue-alpha-16: rgba(70, 130, 255, 0.16);
  --remotion-studio-timeline-marquee-blue-alpha-75: rgba(70, 130, 255, 0.75);
  --remotion-studio-easing-selected-background: rgba(11, 132, 243, 0.18);
  --remotion-studio-info-blue-background: rgba(59, 130, 246, 0.15);
  --remotion-studio-color-picker-checker-background-color: var(--remotion-studio-background);
  --remotion-studio-color-picker-hue-gradient: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
  --remotion-studio-timeline-audio-gradient: linear-gradient(rgb(16 171 58), rgb(43 165 63) 60%);
  --remotion-studio-timeline-video-gradient: linear-gradient(to top, #8e44ad, #9b59b6);
  --remotion-studio-timeline-captions-gradient: linear-gradient(to top, #b96516, #cc7828);
  --remotion-studio-focus-color: #555;
  --remotion-studio-color-picker-checker-color: var(--remotion-studio-white-alpha-15);
  --remotion-studio-info-blue-border-color: rgba(59, 130, 246, 0.4);
  --remotion-studio-black-alpha-22: rgba(0, 0, 0, 0.22);
  --remotion-studio-font-family-error-color: #ff8a8a;
  --remotion-studio-selected-outline-snap-color: #ff00ff;
  --remotion-studio-prism-text-color: #d4d4d4;
  --remotion-studio-prism-selection-background: #264f78;
  --remotion-studio-prism-background: #1e1e1e;
  --remotion-studio-prism-inline-color: #db4c69;
  --remotion-studio-prism-keyword-color: #569cd6;
  --remotion-studio-prism-variable-color: #9cdcfe;
  --remotion-studio-prism-comment-color: #6a9955;
  --remotion-studio-prism-number-color: #b5cea8;
  --remotion-studio-prism-string-color: #ce9178;
  --remotion-studio-prism-control-flow-color: #c586c0;
  --remotion-studio-prism-function-color: #dcdcaa;
  --remotion-studio-prism-regex-color: #d16969;
  --remotion-studio-prism-class-name-color: #4ec9b0;
  --remotion-studio-prism-selector-color: #d7ba7d;
  --remotion-studio-prism-line-highlight-background: #f7ebc6;
  --remotion-studio-prism-line-highlight-border-color: #f7d87c;
}
`;

export { studioCssVariables };
